import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'pptl-auth',
  templateUrl: 'auth.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AuthComponent {

  constructor(){
  }
}
